/* 
- Defines the instances or variables of a survey
- e.g. An anatomy specific survey would have an iip of anatomy
- The promis10 would not
*/

import { postgrest_operators } from "../../helpers/HttpHelper";
import { types } from "../../helpers/Util";
import { DatabaseTable, getTableRow, returnID } from "../BaseTable";

// for display only
// represents the UI schema for interaction instance props
// add more standard instance props here as needed
export interface InteractionInstanceProperties {
  anatomy: boolean;
}

class InteractionInstancePropertyRaw extends DatabaseTable {
  id: number;
  interaction_id: number;
  type: string; // TODO - in the future this will be a deeply nested; complicated representation of a model
  modified: Date;

  // This allows us to do typing in js
  static readonly serializableFields = new Map([
    ["id", [types.number]],
    ["interaction_id", [types.number]],
    ["type", [types.date, types.string]],
    ["modified", [types.date, types.string]],

  ]);
  static readonly tableName = "InteractionInstanceProperty";
  constructor(
    id = -1,
    interaction_id = -1,
    type = "",
    modified = new Date(),
  ) {
    super();
    this.id = returnID(id);
    this.interaction_id = interaction_id;
    this.type = type;
    this.modified = modified;
  }
}


class InteractionInstanceProperty extends InteractionInstancePropertyRaw {
  constructor(...args: any[]) {
    super(...args);
  }
  // add new InteractionInstanceProperty and return it
  // (NOTE: this has been tested and works,
  //   provided the interaction_id fk isn't already in table)
  public static async add(
    interaction_id: number,
    type: string) {
    let newInteractionInstanceProperty = null;
    if (interaction_id == -1 || !interaction_id || !type || type == "") {
      return;
    }
    // find existing properties
    const existingInteractionInstanceProperties = await InteractionInstanceProperty.queryTable([
      {
        operator: postgrest_operators.eq,
        column: "type",
        value: type,
      },
      {
        operator: postgrest_operators.eq,
        column: "interaction_id",
        value: "" + interaction_id
      }
    ])
    // create new instance
    newInteractionInstanceProperty = await InteractionInstanceProperty.createInstance({
      interaction_id: interaction_id,
      type: type
    })
    // only save to db if prop doesnt already exist there
    // (@FIXME db should be updated so it cannot accept dupes)
    if ((!existingInteractionInstanceProperties || existingInteractionInstanceProperties.length < 1)) {
      newInteractionInstanceProperty.save();
    }

    return newInteractionInstanceProperty;
  }

  public static async delete(
    interaction_id: number,
    type: string
  ) {
    if (interaction_id == -1 || !interaction_id || !type || type == "") {
      return;
    }
    const newInteractionInstanceProperties = await InteractionInstanceProperty.queryTable([
      {
        operator: postgrest_operators.eq,
        column: "type",
        value: type,
      },
      {
        operator: postgrest_operators.eq,
        column: "interaction_id",
        value: "" + interaction_id
      }
    ])
    // delete all found results
    newInteractionInstanceProperties.forEach((newInteractionInstanceProperty) => {
      newInteractionInstanceProperty.delete();
    })
  };

  public static async saveAllInteractionInstanceProperties(
    interactionInstanceProperties: InteractionInstanceProperties,
    interaction_id: number) {
    Object.keys(interactionInstanceProperties).forEach((key: string) => {
      // if value is truthy, we want to add it
      // (db doesnt allow dupes)
      if (interactionInstanceProperties[key as keyof InteractionInstanceProperties]) {
        InteractionInstanceProperty.add(interaction_id, key)
      } else {
        InteractionInstanceProperty.delete(interaction_id, key)
      }

    })
  }

}

export default InteractionInstanceProperty;